{#if isOpen}
  <div
    class="jolojo-ui__modal-backdrop"
    transition:fade={{ duration: 200 }}
    on:click|self={isDismissable ? closeModal : null}
    on:keydown={handleKeydown}
    role="presentation"
  >
    <div
      bind:this={modalElement}
      class="jolojo-ui__modal"
      role="dialog"
      aria-modal="true"
      tabindex="-1"
      transition:scale={{ duration: 200, start: 0.95 }}
      style={`max-width: ${width}px; left: ${position.x}px; top: ${position.y}px;`}
    >
      <Flex direction="column" gap="lg" padding="md">
        <div class="header">
          <Flex justify="space-between" align="center">
            <Flex gap="xs" align="center">
              {#if draggable}
                <div
                  class="drag-handle"
                  on:mousedown={startDragging}
                  role="button"
                  tabindex="0"
                >
                  <MaterialIcon icon="drag_indicator" />
                </div>
              {/if}
              {#if modalTitle}
                <div class="modal-title">
                  {modalTitle}
                </div>
              {/if}
            </Flex>
            <button style="background: none; border: none; padding: 0; cursor: pointer;" on:click={closeModal}>
              <MaterialIcon icon="close" />
            </button>
          </Flex>
        </div>

        <div class="body">
          <slot />
        </div>

        <div class="footer">
          <Flex justify="flex-end" gap="sm">
            {#if onSave}
              <Button size="md" on:click={saveModal}>
                <Flex gap="md" align="center">
                  <span>Save</span>
                  <MaterialIcon icon="save" colour="white"/>
                </Flex>
              </Button>
            {/if}
          </Flex>
        </div>
      </Flex>

      <div class="aside aside-right">
        <slot name="aside-right" />
      </div>

    </div>
  </div>
{/if}

<script>
  import { onDestroy } from 'svelte'
  import { fade, scale } from 'svelte/transition'

  import Button from '@/components/ui/button/Button.svelte'
  import Flex from '@/components/ui/flex/Flex.svelte'
  import MaterialIcon from '@/components/ui/material_icon/MaterialIcon.svelte'

  export let isOpen = false

  export let modalTitle = null
  export let width = 'auto'
  export let draggable = false
  export let isDismissable = false

  export let onClose = null
  export let onSave = null

  let modalElement

  let isDragging = false
  let position = { x: 0, y: 0 }
  const offset = { x: 0, y: 0 }

  let resizeObserver

  $: if (isOpen && modalElement) {
    modalElement.focus()

    resizeObserver = new ResizeObserver(() => {
      const modalHeight = modalElement.offsetHeight
      position = {
        x: (window.innerWidth - modalElement.offsetWidth) / 2,
        y: (window.innerHeight - modalHeight) / 2,
      }
    })

    resizeObserver.observe(modalElement)
  } else if (resizeObserver) {
    resizeObserver.disconnect()
  }

  function handleKeydown (event) {
    if (event.key === 'Escape') {
      closeModal()
    }
  }

  function closeModal () {
    if (onClose) {
      onClose()
    }
    isOpen = false
  }

  function saveModal () {
    isOpen = false
    onSave()
  }

  function startDragging (event) {
    isDragging = true
    offset.x = event.clientX - position.x
    offset.y = event.clientY - position.y

    window.addEventListener('mousemove', handleDragging)
    window.addEventListener('mouseup', stopDragging)
  }

  function handleDragging (event) {
    if (isDragging) {
      position.x = event.clientX - offset.x
      position.y = event.clientY - offset.y
    }
  }

  function stopDragging () {
    isDragging = false
    window.removeEventListener('mousemove', handleDragging)
    window.removeEventListener('mouseup', stopDragging)
  }

  onDestroy(() => {
    if (resizeObserver) {
      resizeObserver.disconnect()
    }
    if (typeof window !== 'undefined') {
      window.removeEventListener('mousemove', handleDragging)
      window.removeEventListener('mouseup', stopDragging)
    }
  })

</script>

<style>
  .jolojo-ui__modal-backdrop {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 999;
  }

  .jolojo-ui__modal {
    position: fixed;
    background: white;
    border-radius: var(--jolojo-ui-md-border-radius);
    width: fit-content;
    outline: none;
    max-height: 80vh;
    display: flex;
    overflow: hidden;
    background: var(--jolojo-ui-bg-1);
  }

  .header {
    width: 100%;
  }

  .modal-title {
    font-size: var(--jolojo-ui-lg-font-size);
    font-weight: 600;
  }

  .body {
    width: 100%;
    height: 100%;
  }

  .footer {
    width: 100%;
  }

  .drag-handle {
    cursor: move !important;
  }

</style>
<script context="module">export const svelteCompilerVersion = {"major":4,"minor":2,"patch":18};</script>